import React from "react";
import "../../styles/forms/Form.css";
import { useSelector, useDispatch } from "react-redux";
import PayerDetails from "./GlobalFormComponents/PayerDetails";
import RecipientDetails from "./GlobalFormComponents/RecipientDetails";
import RecAccount from "./GlobalFormComponents/RecAccount";
import FormDetail from "./GlobalFormComponents/InternalComponents/FormDetail";
import {
  AMOUNT_1,
  AMOUNT_2,
  AMOUNT_3,
  AMOUNT_4,
  AMOUNT_5,
  AMOUNT_6,
  AMOUNT_8,
  AMOUNT_A,
  AMOUNT_B,
  AMOUNT_C,
  AMOUNT_D,
  AMOUNT_E,
  AMOUNT_F,
  CORRECTION_INITIAL,
  DEFAULT_NON_FOREIGN_COUNTRY,
  ERROR_POPUP,
  MISC_1099,
  PAGE_E_FILE,
} from "../../lib/constants";
import AmountContainer from "./GlobalFormComponents/AmountContainer/AmountContainer";
import AmountHeading from "./GlobalFormComponents/AmountContainer/AmountHeading/AmountHeading";
import Amount from "./GlobalFormComponents/AmountContainer/AmountInput/Amount";
import StateInfo from "./GlobalFormComponents/StateInfo";
import { misc1099AmountDisplayTexts, stateInfoDisplayTexts } from "../../lib/languagePacks/en-us";
import SubmitButton from "../SubmitButton/SubmitButton";
import Fatca from "./GlobalFormComponents/FATCA/Fatca";
import { useEffect, useState } from "react";
import handleAmountFormat from "../../lib/form/utils/handleAmountFormat";
import logger from "../../logger";
import formSubmissionHelper from "../../lib/FormSubmission/formSubmissionHelper";
import { useNavigate } from "react-router-dom";
import UpdateButton from "../UpdateButton/UpdateButton";
import { isValidAmount } from "./Form1099-B";
import Middleware from "../../lib/utils/Middleware";
import handlePopup from "../../lib/popup/handlePopup";
import devLogInstance from "../../lib/loggerConfig";
import SessionStorage from "../../lib/LocalCaching/SessionStorage";
import CorrectionSubmissionType from "./GlobalFormComponents/CorrectionRelated/CorrectionSubmissionType";
import { useRecTinUnknown } from "../../lib/customHooks";

export default function Form1099MISC({
  formData,
  setFormData,
  formType,
  taxYear,
  isEditable,
  isCorrection,
  historyId,
}: any) {
  const style = useSelector((state: any) => state.themeChange);
  const dispatch = useDispatch();
  const [amount, setAmount] = useState({
    amount1: "",
    amount2: "",
    amount3: "",
    amount4: "",
    amount5: "",
    amount6: "",
    amount8: "",
    amountA: "",
    amountB: "",
    amountC: "",
    amountD: "",
    amountE: "",
    amountF: "",
  }); // for displaying on the input field
  const navigate = useNavigate();
  const correctionSubmissionType = useSelector((state: any) => state.correctionSubmissionType);

  const { recTinUnknown } = useRecTinUnknown();

  // Set the amount values
  useEffect(() => {
    setAmount({
      amount1: formData.payment_amount1
        ? handleAmountFormat((formData.payment_amount1 / 100).toString())
        : "",
      amount2: formData.payment_amount2
        ? handleAmountFormat((formData.payment_amount2 / 100).toString())
        : "",
      amount3: formData.payment_amount3
        ? handleAmountFormat((formData.payment_amount3 / 100).toString())
        : "",
      amount4: formData.payment_amount4
        ? handleAmountFormat((formData.payment_amount4 / 100).toString())
        : "",
      amount5: formData.payment_amount5
        ? handleAmountFormat((formData.payment_amount5 / 100).toString())
        : "",
      amount6: formData.payment_amount6
        ? handleAmountFormat((formData.payment_amount6 / 100).toString())
        : "",
      amount8: formData.payment_amount8
        ? handleAmountFormat((formData.payment_amount8 / 100).toString())
        : "",
      amountC: formData.payment_amountC
        ? handleAmountFormat((formData.payment_amountC / 100).toString())
        : "",
      amountA: formData.payment_amountA
        ? handleAmountFormat((formData.payment_amountA / 100).toString())
        : "",
      amountB: formData.payment_amountB
        ? handleAmountFormat((formData.payment_amountB / 100).toString())
        : "",
      amountD: formData.payment_amountD
        ? handleAmountFormat((formData.payment_amountD / 100).toString())
        : "",
      amountE: formData.payment_amountE
        ? handleAmountFormat((formData.payment_amountE / 100).toString())
        : "",
      amountF: formData.payment_amountF
        ? handleAmountFormat((formData.payment_amountF / 100).toString())
        : "",
    });

    return () => {
      setAmount({
        amount1: "",
        amount2: "",
        amount3: "",
        amount4: "",
        amount5: "",
        amount6: "",
        amount8: "",
        amountA: "",
        amountB: "",
        amountC: "",
        amountD: "",
        amountE: "",
        amountF: "",
      });
    };
  }, [
    formData.payment_amount1,
    formData.payment_amount2,
    formData.payment_amount3,
    formData.payment_amount4,
    formData.payment_amount5,
    formData.payment_amount6,
    formData.payment_amount8,
    formData.payment_amountA,
    formData.payment_amountB,
    formData.payment_amountC,
    formData.payment_amountD,
    formData.payment_amountE,
    formData.payment_amountF,
  ]);

  // Update the direct sales indicator on global data
  const updateDirectSalesIndicator = () => {
    setFormData({
      ...formData,
      direct_sales_indicator: !formData.direct_sales_indicator,
    });
  };

  // Handle input change on payment amount fields
  const handleChange = (e: any) => {
    const { id, value } = e.target;
    const formattedAmount = handleAmountFormat(value);
    switch (id) {
      case AMOUNT_1:
        isValidAmount(formattedAmount) &&
          setAmount({
            ...amount,
            amount1: formattedAmount,
          });
        break;
      case AMOUNT_2:
        isValidAmount(formattedAmount) &&
          setAmount({
            ...amount,
            amount2: formattedAmount,
          });
        break;
      case AMOUNT_3:
        isValidAmount(formattedAmount) &&
          setAmount({
            ...amount,
            amount3: formattedAmount,
          });
        break;
      case AMOUNT_4:
        isValidAmount(formattedAmount) &&
          setAmount({
            ...amount,
            amount4: formattedAmount,
          });
        break;
      case AMOUNT_5:
        isValidAmount(formattedAmount) &&
          setAmount({
            ...amount,
            amount5: formattedAmount,
          });
        break;
      case AMOUNT_6:
        isValidAmount(formattedAmount) &&
          setAmount({
            ...amount,
            amount6: formattedAmount,
          });
        break;
      case AMOUNT_8:
        isValidAmount(formattedAmount) &&
          setAmount({
            ...amount,
            amount8: formattedAmount,
          });
        break;
      case AMOUNT_A:
        isValidAmount(formattedAmount) &&
          setAmount({
            ...amount,
            amountA: formattedAmount,
          });
        break;
      case AMOUNT_B:
        isValidAmount(formattedAmount) &&
          setAmount({
            ...amount,
            amountB: formattedAmount,
          });
        break;
      case AMOUNT_C:
        isValidAmount(formattedAmount) &&
          setAmount({
            ...amount,
            amountC: formattedAmount,
          });
        break;
      case AMOUNT_D:
        isValidAmount(formattedAmount) &&
          setAmount({
            ...amount,
            amountD: formattedAmount,
          });
        break;
      case AMOUNT_E:
        isValidAmount(formattedAmount) &&
          setAmount({
            ...amount,
            amountE: formattedAmount,
          });
        break;
      case AMOUNT_F:
        isValidAmount(formattedAmount) &&
          setAmount({
            ...amount,
            amountF: formattedAmount,
          });
        break;

      default:
        break;
    }
  };

  // Handle form submit
  const handleFormSubmit = (e: any) => {
    e.preventDefault();
    const { id: submitType } = e.target;

    let data = {
      ...formData,
      payer_country: !formData.payer_is_foreign_address
        ? DEFAULT_NON_FOREIGN_COUNTRY
        : formData.payer_country,
      recipient_country: !formData.recipient_is_foreign_address
        ? DEFAULT_NON_FOREIGN_COUNTRY
        : formData.recipient_country,
      form_type: formType,
      payment_amount1: amount.amount1 ? parseFloat(amount.amount1.replace(/,/gi, "")) : 0,
      payment_amount2: amount.amount2 ? parseFloat(amount.amount2.replace(/,/gi, "")) : 0,
      payment_amount3: amount.amount3 ? parseFloat(amount.amount3.replace(/,/gi, "")) : 0,
      payment_amount4: amount.amount4 ? parseFloat(amount.amount4.replace(/,/gi, "")) : 0,
      payment_amount5: amount.amount5 ? parseFloat(amount.amount5.replace(/,/gi, "")) : 0,
      payment_amount6: amount.amount6 ? parseFloat(amount.amount6.replace(/,/gi, "")) : 0,
      payment_amount8: amount.amount8 ? parseFloat(amount.amount8.replace(/,/gi, "")) : 0,
      payment_amountA: amount.amountA ? parseFloat(amount.amountA.replace(/,/gi, "")) : 0,
      payment_amountB: amount.amountB ? parseFloat(amount.amountB.replace(/,/gi, "")) : 0,
      payment_amountC: amount.amountC ? parseFloat(amount.amountC.replace(/,/gi, "")) : 0,
      payment_amountD: amount.amountD ? parseFloat(amount.amountD.replace(/,/gi, "")) : 0,
      payment_amountF: amount.amountF ? parseFloat(amount.amountF.replace(/,/gi, "")) : 0,
    };
    logger.log(data);

    const paymentAmounts = [
      data.payment_amount1,
      data.payment_amount2,
      data.payment_amount3,
      data.payment_amount4,
      data.payment_amount5,
      data.payment_amount6,
      data.payment_amount8,
      data.payment_amountA,
      data.payment_amountB,
      data.payment_amountC,
      data.payment_amountD,
      data.payment_amountF,
    ];
    const incomeAmounts = [
      data.payment_amount1,
      data.payment_amount2,
      data.payment_amount3,
      data.payment_amount5,
      data.payment_amount6,
      data.payment_amount8,
      data.payment_amountA,
      data.payment_amountB,
      data.payment_amountC,
      data.payment_amountD,
      data.payment_amountF,
    ];

    // Correction filing middleware
    Middleware.fileCorrection(
      {
        isCorrection: isCorrection,
        correctionSubmissionType: correctionSubmissionType,
        correctionCode1Details: data,
        correctionCode2Details: data,
        formType: data.form_type,
      },
      (err, correctionCode) => {
        if (err) {
          console.error(err);
          handlePopup(err, ERROR_POPUP, dispatch);
          return;
        }

        if (correctionCode) {
          data = {
            ...data,
            file_submission_type: correctionSubmissionType,
            correction_type: correctionCode,
            payer_is_new_or_updated: false,
            history_id: historyId,
          };
          devLogInstance.log("Data before sumbitting correction");
          devLogInstance.log(data);
        }

        devLogInstance.log("Removing cached intial data...");
        SessionStorage.removeCacheItem(CORRECTION_INITIAL);
        devLogInstance.log("Cache removed!");

        formSubmissionHelper(
          data,
          paymentAmounts,
          data.payment_amount4,
          incomeAmounts,
          setFormData,
          setAmount,
          dispatch,
          submitType,
          navigate,
          PAGE_E_FILE,
          recTinUnknown
        );
      }
    );
    // formSubmissionHelper(
    //   data,
    //   paymentAmounts,
    //   data.payment_amount4,
    //   incomeAmounts,
    //   setFormData,
    //   setAmount,
    //   dispatch,
    //   submitType,
    //   navigate,
    //   PAGE_E_FILE
    // );
  };
  return (
    <>
      <form className="form-main-container">
        {isCorrection && <CorrectionSubmissionType />}
        <div
          className="form-wrapper"
          style={{
            border: `2px solid ${style.eFormBorderColor}`,
          }}
        >
          <div className="form-details-amount-wrapper">
            <div className="left-portion-details">
              <PayerDetails
                globalFormData={formData}
                setGlobalFormData={setFormData}
                isCorrection={isCorrection}
              />
              <RecipientDetails
                globalFormData={formData}
                setGlobalFormData={setFormData}
                formType={formType}
                isCorrection={isCorrection}
              />
              <Fatca
                displayCode={"13"}
                globalFormData={formData}
                setGlobalFormData={setFormData}
                type={"filing-form"}
              />
              <RecAccount globalFormData={formData} setGlobalFormData={setFormData} />
            </div>
            <div
              className="right-portion-details"
              style={{
                overflow: "hidden",
                borderBottom: `1px solid ${style.eFormBorderColor}`,
              }}
            >
              <div className="top-section">
                <div>
                  <AmountContainer
                    class_="misc-info" // Only one class can be passed
                    style={{
                      borderTop: `1px solid ${style.eFormBorderColor}`,
                    }}
                  >
                    <AmountHeading heading={misc1099AmountDisplayTexts.rents} amountNum="1" />
                    <Amount
                      type="text"
                      id={AMOUNT_1}
                      placeHolder="0.00"
                      class_="payer-details-input" // Only one class can be passed
                      value={amount.amount1}
                      onChangeHandler={handleChange}
                    />
                  </AmountContainer>
                  <AmountContainer
                    class_="misc-info" // Only one class can be passed
                    style={{
                      borderTop: `1px solid ${style.eFormBorderColor}`,
                    }}
                  >
                    <AmountHeading heading={misc1099AmountDisplayTexts.royalties} amountNum="2" />
                    <Amount
                      type="text"
                      id={AMOUNT_2}
                      placeHolder="0.00"
                      class_="payer-details-input" // Only one class can be passed
                      value={amount.amount2}
                      onChangeHandler={handleChange}
                    />
                  </AmountContainer>
                </div>
                <FormDetail formType={formType} taxYear={taxYear} formName={MISC_1099} />
              </div>

              <div
                className="payment-amounts-container"
                style={{
                  borderRight: `1px solid ${style.eFormBorderColor}`,
                  borderBottom: `1px solid ${style.eFormBorderColor}`,
                }}
              >
                <AmountContainer
                  class_="misc-info" // Only one class can be passed
                  style={{
                    borderRight: `1px solid ${style.eFormBorderColor}`,
                  }}
                >
                  <AmountHeading heading={misc1099AmountDisplayTexts.otherIncome} amountNum="3" />
                  <Amount
                    type="text"
                    id={AMOUNT_3}
                    placeHolder="0.00"
                    class_="payer-details-input" // Only one class can be passed
                    value={amount.amount3}
                    onChangeHandler={handleChange}
                  />
                </AmountContainer>
                <AmountContainer
                  class_="misc-info" // Only one class can be passed
                >
                  <AmountHeading
                    heading={misc1099AmountDisplayTexts.incomeTaxWithheldDisplayText}
                    amountNum="4"
                  />
                  <Amount
                    type="text"
                    id={AMOUNT_4}
                    placeHolder="0.00"
                    class_="payer-details-input" // Only one class can be passed
                    value={amount.amount4}
                    onChangeHandler={handleChange}
                  />
                </AmountContainer>
              </div>
              <div
                className="payment-amounts-container"
                style={{
                  borderRight: `1px solid ${style.eFormBorderColor}`,
                  borderBottom: `1px solid ${style.eFormBorderColor}`,
                }}
              >
                <AmountContainer
                  class_="misc-info" // Only one class can be passed
                  style={{
                    borderRight: `1px solid ${style.eFormBorderColor}`,
                  }}
                >
                  <AmountHeading
                    heading={misc1099AmountDisplayTexts.fishingBoatProceeds}
                    amountNum="5"
                  />
                  <Amount
                    type="text"
                    id={AMOUNT_5}
                    placeHolder="0.00"
                    class_="payer-details-input" // Only one class can be passed
                    value={amount.amount5}
                    onChangeHandler={handleChange}
                  />
                </AmountContainer>
                <AmountContainer
                  class_="misc-info" // Only one class can be passed
                >
                  <AmountHeading
                    heading={misc1099AmountDisplayTexts.medicalHealthCarePayments}
                    amountNum="6"
                  />
                  <Amount
                    type="text"
                    id={AMOUNT_6}
                    placeHolder="0.00"
                    class_="payer-details-input" // Only one class can be passed
                    value={amount.amount6}
                    onChangeHandler={handleChange}
                  />
                </AmountContainer>
              </div>
              <div
                className="payment-amounts-container"
                style={{
                  borderRight: `1px solid ${style.eFormBorderColor}`,
                  borderBottom: `1px solid ${style.eFormBorderColor}`,
                }}
              >
                <AmountContainer
                  class_="payer-direct-sales" // Only one class can be passed
                  style={{
                    borderRight: `1px solid ${style.eFormBorderColor}`,
                  }}
                >
                  <div className="flex items-center gap-2">
                    <AmountHeading
                      heading={misc1099AmountDisplayTexts.directSalesDisplayText}
                      amountNum="7"
                    />
                    <input
                      type="checkbox"
                      id="direct-sales"
                      checked={formData.direct_sales_indicator}
                      onChange={updateDirectSalesIndicator}
                    />
                  </div>
                </AmountContainer>
                <AmountContainer
                  class_="misc-info" // Only one class can be passed
                >
                  <AmountHeading
                    heading={misc1099AmountDisplayTexts.substitutePayments}
                    amountNum="8"
                  />
                  <Amount
                    type="text"
                    id={AMOUNT_8}
                    placeHolder="0.00"
                    class_="payer-details-input" // Only one class can be passed
                    value={amount.amount8}
                    onChangeHandler={handleChange}
                  />
                </AmountContainer>
              </div>
              <div
                className="payment-amounts-container"
                style={{
                  borderRight: `1px solid ${style.eFormBorderColor}`,
                  borderBottom: `1px solid ${style.eFormBorderColor}`,
                }}
              >
                <AmountContainer
                  class_="misc-info" // Only one class can be passed
                  style={{
                    borderRight: `1px solid ${style.eFormBorderColor}`,
                  }}
                >
                  <AmountHeading
                    heading={misc1099AmountDisplayTexts.cropInsProceeds}
                    amountNum="9"
                  />
                  <Amount
                    type="text"
                    id={AMOUNT_A}
                    placeHolder="0.00"
                    class_="payer-details-input" // Only one class can be passed
                    value={amount.amountA}
                    onChangeHandler={handleChange}
                  />
                </AmountContainer>
                <AmountContainer
                  class_="misc-info" // Only one class can be passed
                >
                  <AmountHeading
                    heading={misc1099AmountDisplayTexts.grossProceedsPaidToAttorney}
                    amountNum="10"
                  />
                  <Amount
                    type="text"
                    id={AMOUNT_C}
                    placeHolder="0.00"
                    class_="payer-details-input" // Only one class can be passed
                    value={amount.amountC}
                    onChangeHandler={handleChange}
                  />
                </AmountContainer>
              </div>
              <div
                className="payment-amounts-container"
                style={{
                  borderRight: `1px solid ${style.eFormBorderColor}`,
                  borderBottom: `1px solid ${style.eFormBorderColor}`,
                }}
              >
                <AmountContainer
                  class_="misc-info" // Only one class can be passed
                  style={{
                    borderRight: `1px solid ${style.eFormBorderColor}`,
                  }}
                >
                  <AmountHeading
                    heading={misc1099AmountDisplayTexts.fishPurchasedForResale}
                    amountNum="11"
                  />
                  <Amount
                    type="text"
                    id={AMOUNT_F}
                    placeHolder="0.00"
                    class_="payer-details-input" // Only one class can be passed
                    value={amount.amountF}
                    onChangeHandler={handleChange}
                  />
                </AmountContainer>
                <AmountContainer
                  class_="misc-info" // Only one class can be passed
                >
                  <AmountHeading
                    heading={misc1099AmountDisplayTexts.section409ADeferrals}
                    amountNum="12"
                  />
                  <Amount
                    type="text"
                    id={AMOUNT_D}
                    placeHolder="0.00"
                    class_="payer-details-input" // Only one class can be passed
                    value={amount.amountD}
                    onChangeHandler={handleChange}
                  />
                </AmountContainer>
              </div>
              <div
                className="payment-amounts-container"
                style={{
                  borderRight: `1px solid ${style.eFormBorderColor}`,
                  borderBottom: `1px solid ${style.eFormBorderColor}`,
                }}
              >
                <AmountContainer
                  class_="misc-info" // Only one class can be passed
                  style={{
                    borderRight: `1px solid ${style.eFormBorderColor}`,
                  }}
                >
                  <AmountHeading
                    heading={misc1099AmountDisplayTexts.glodenParachutePayments}
                    amountNum="14"
                  />
                  <Amount
                    type="text"
                    id={AMOUNT_B}
                    placeHolder="0.00"
                    class_="payer-details-input" // Only one class can be passed
                    value={amount.amountB}
                    onChangeHandler={handleChange}
                  />
                </AmountContainer>
                <AmountContainer
                  class_="misc-info" // Only one class can be passed
                >
                  <AmountHeading
                    heading={misc1099AmountDisplayTexts.deferredCompensation}
                    amountNum="15"
                  />
                  <Amount
                    type="text"
                    id={AMOUNT_E}
                    placeHolder="0.00"
                    class_="payer-details-input" // Only one class can be passed
                    value={amount.amountE}
                    onChangeHandler={handleChange}
                  />
                </AmountContainer>
              </div>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  borderRight: `1px solid ${style.eFormBorderColor}`,
                }}
              />
            </div>
          </div>
        </div>
        <StateInfo
          state1Heading={stateInfoDisplayTexts.misc1099.state1.heading}
          state2Heading={stateInfoDisplayTexts.misc1099.state2.heading}
          taxWithheldLabel={stateInfoDisplayTexts.misc1099.stateTaxWithheldLabel}
          stateVolLabel={stateInfoDisplayTexts.misc1099.stateLabel}
          stateNoLabel={stateInfoDisplayTexts.misc1099.stateNoLabel}
          stateIncomeLabel={stateInfoDisplayTexts.misc1099.stateIncLabel}
          globalFormData={formData}
          setGlobalFormData={setFormData}
          isCorrection={isCorrection}
        />
      </form>
      {!isEditable ? (
        <SubmitButton handleSubmit={handleFormSubmit} isCorrection={isCorrection} />
      ) : (
        <UpdateButton handleUpdate={handleFormSubmit} />
      )}
    </>
  );
}
